// Helpers for building pending subtask entries during new-task creation.
import {
  TASK_FORM_DEFAULT_SUBTASK_DURATION_MINS,
  TASK_FORM_PENDING_ID_RADIX,
} from '@/features/tasks/components/forms/taskFormConstants';

export function createPendingSubtaskLocalId() {
  return `pending-${Date.now()}-${Math.random().toString(TASK_FORM_PENDING_ID_RADIX).slice(2)}`;
}

/**
 * @param {import('@/types').Task} task
 * @param {import('@/types').Task|Object|null|undefined} parsedData
 */
function resolvePendingSubtaskDuration(task, parsedData) {
  if (task.duration !== undefined && task.duration !== null)
    return task.duration;
  if (parsedData?.duration !== undefined && parsedData?.duration !== null)
    return parsedData.duration;
  return TASK_FORM_DEFAULT_SUBTASK_DURATION_MINS;
}

/**
 * @param {import('@/types').Task|Object|null|undefined} parsedData
 */
function resolvePendingSubtaskMetadata(parsedData) {
  return {
    title: parsedData?.title ?? '',
    projects: parsedData?.projects ?? [],
    contexts: parsedData?.contexts ?? [],
    person: parsedData?.person ?? null,
    recurrence: parsedData?.recurrence ?? null,
    date: parsedData?.date ?? null,
  };
}

/**
 * @param {import('@/types').Task} task
 * @param {import('@/types').Task|Object|null|undefined} parsedData
 */
export function buildPendingSubtaskEntry(task, parsedData) {
  return {
    localId: createPendingSubtaskLocalId(),
    ...resolvePendingSubtaskMetadata(parsedData),
    description: null,
    completed: false,
    duration: resolvePendingSubtaskDuration(task, parsedData),
    status: task.status ?? 'Active',
    time: null,
  };
}
